import {
    ADMINMAPPINGLANGUAGE_SUCCESS,
    ADMINMAPPINGLANGUAGE_FAILED,
    RESET_ADMINMAPPINGLANGUAGE,
    LOADING_ADMINMAPPINGLANGUAGE,
    NETWORK_ERROR_ADMINMAPPINGLANGUAGE
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetGetAdminMappingLanguage = () => {
    return { type: RESET_ADMINMAPPINGLANGUAGE };
};

const getAdminmappingLanguage = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADMINMAPPINGLANGUAGE });
    await adminServices
        .post("mappingLanguage", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(adminMappingLanguagesuccess(res.data));
                    break;
                default:
                    dispatch(adminMappingLanguageFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADMINMAPPINGLANGUAGE,
                payload: err
            });
        });
};


function adminMappingLanguagesuccess(data) {
    return {
        type: ADMINMAPPINGLANGUAGE_SUCCESS,
        payload: data
    };
}
function adminMappingLanguageFailed(data) {
    return {
        type: ADMINMAPPINGLANGUAGE_FAILED,
        payload: data
    };
}

export { getAdminmappingLanguage, resetGetAdminMappingLanguage }